export default __webpack_public_path__ + "static/media/img_3.ffdde640.jpg";